import gql from 'graphql-tag'

const query = gql`
query listCashRegisters($deviceType: cashRegisterType) {
	cashAssist {
		listCashRegisters(
			deviceType: $deviceType,
			params: {
				sort: [{ field: "name", order: ASC }]
			}
		) {
	    id
	    name
	    shop {
	    	id
	    	name
	    }
	  }
	}
}`

export default query
